import { HttpClient } from "@angular/common/http";
import { Injectable } from "@angular/core";

import { Observable, Subject } from "rxjs";

import { DealerProductsType, PlanDurationType, PolicyDetails, PolicyInfo, PrePolicyModel } from "../models";
import { ConfigService } from "./config.service";
import { HeaderFactoryService } from "./header-factory.service";

@Injectable()
export class PolicyService {
  public policySearchResultObservable = new Subject<PolicyDetails>();

  private policyDetailsResult: PolicyDetails;

  constructor(
    private httpsClient: HttpClient,
    private headerService: HeaderFactoryService,
    private configService: ConfigService
  ) {}

  search(filterName: string, filterValue: string): Observable<PolicyInfo[]> {
    return this.httpsClient.get<PolicyInfo[]>(
      `${this.configService.apiUrl}api/v${this.configService.apiVersion}/policy/search/${filterName}/${filterValue}`,
      this.headerService.getAuthorizationHeaderOptions()
    );
  }

  public policyDetails(certficateNumber: string) {
    return this.httpsClient.post<PolicyDetails>(
      `${this.configService.apiUrl}api/v${this.configService.apiVersion}/policy/policyDetails/${certficateNumber}`,
      null,
      this.headerService.getAuthorizationHeaderOptions()
    );
  }

  public savePolicyDetails(policyDetails: PolicyDetails) {
    this.policyDetailsResult = policyDetails;
    this.policySearchResultObservable.next(policyDetails);
  }

  public getPolicyDetails() {
    return this.policyDetailsResult;
  }

  public generatePolicyNumber(insuranceType: DealerProductsType, salesId:string) {
    return this.httpsClient.get<PrePolicyModel>(
      `${this.configService.apiUrl}api/v${this.configService.apiVersion}/policy/prePolicyInfo/${insuranceType}/${salesId}`,
      this.headerService.getAuthorizationHeaderOptions()
    );
  }

  public getPlanDurationTypeByDuration(
    DurationInMonths: number
  ): PlanDurationType {
    switch (DurationInMonths) {
      case 12:
      case 24:
        return PlanDurationType.Yearly;

      default:
        return PlanDurationType.Monthly;
    }
  }
}
